/* eslint-disable @typescript-eslint/no-floating-promises */
import Header from './components/Header';
import { BrowserRouter, Route, Routes } from 'react-router';
import './App.css';
import ShowPage from './components/TVShow/ShowPage';
import WatchListPage from './components/WatchList/WatchListPage';
import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { UserContext, User } from './contexts/UserContext';
import { getUserProfile, createUserProfile } from './utils';
import Profile from './components/Profile/Profile';
import { ProfileContext } from './contexts/ProfileContext';
import { ProfileInfo } from './types';
import { ToastContainer } from 'react-toastify';
import FAQ from './components/FAQ';
import StatsPage from './components/Stats/StatsPage';

function App() {
  const { user, isAuthenticated, loginWithRedirect, getAccessTokenSilently, logout } =
    useAuth0();

  const [userMetadata, setUserMetadata] = useState({} as User);
  const [profileMetadata, setProfileMetadata] = useState<ProfileInfo | null>(null);

  const logoutOfApp = async () => {
    await logout({ logoutParams: { returnTo: window.location.origin } });
    setUserMetadata({});
  };

  async function getOrCreateUserProfile(id: string, token: string) {
    if (!id || !token) return;
    // try to pull user profile
    let profile = await getUserProfile(id, token);

    // if !user profile, create one then fetch it
    if (!profile) {
      await createUserProfile(id, token);
      profile = await getUserProfile(id, token);
    }
    setProfileMetadata(profile);
  }

  useEffect(() => {
    const getUserMetadata = async () => {
      if (!user?.sub) return;
      const domain = process.env.AUTH0_DOMAIN;
  
      try {
        const accessToken = await getAccessTokenSilently({
          authorizationParams: {
            audience: `https://${domain}/api/v2/`,
            scope: 'read:current_user'
          }
        });
  
        const userDetailsByIdUrl = `https://${domain}/api/v2/users/${user?.sub}`;
  
        const metadataResponse = await fetch(userDetailsByIdUrl, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        });
  
        const user_metadata = await metadataResponse.json() as User;
        setUserMetadata({ ...user, isAuthenticated, ...user_metadata, accessToken });
        getOrCreateUserProfile(user.sub, accessToken);
      } catch (e) {
        console.error(e);
      }
    };

    if (!user?.sub) return;
    getUserMetadata();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.sub]);

  return (
    <>
      <BrowserRouter>
        <UserContext.Provider value={userMetadata}>
          <ProfileContext.Provider value={profileMetadata}>
            <Header logout={logoutOfApp} login={() => loginWithRedirect()} />
            <Routes>
              <Route
                path="/"
                element={<WatchListPage login={() => loginWithRedirect()} />}
              />
              <Route path="show/:id" element={<ShowPage />} />
              <Route path="profile" element={<Profile setProfile={setProfileMetadata} />}/>
              <Route path="faq" element={<FAQ />} />
              <Route path="stats" element={<StatsPage />} />
            </Routes>
          </ProfileContext.Provider>
        </UserContext.Provider>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
}

export default App;
